import { Navigate } from "react-router-dom";
import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import { lazy } from "react";

const Dashboard = Loadable(lazy(() => import("../Dashboard/index")));
const UnauthorizedAccess = Loadable(lazy(() => import("../../utils/ui-components/UnauthorizedAccess")));
const CampaignView = Loadable(lazy(() => import("../Campaigns/campaign-uses/view-uses/campaign-uses-view")));
const OwnerList = Loadable(lazy(() => import("../Users/user-list")));
const OwnerView = Loadable(lazy(() => import("../Users/view-user")));
const CampaignListReport = Loadable(lazy(() => import("../Reoprts/campaign-list-report")));
const ChildUserList = Loadable(lazy(() => import("../Configurations/userManagement/childUser/child-user-list")));
const ManageChildUserList = Loadable(lazy(() => import("../child-user-managent")));
const FinancialReportChannelWise = Loadable(lazy(() => import("../Reoprts/financial-report-channel-wise")));
// const FinancialReport = Loadable(lazy(() => import('../Reoprts/financial-report')));

function ReportUserAuthorizedRoutes(role: any) {
  return [
    {
      path: "/",
      element: <MainLayout role={role} />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "campaign",
          children: [
            {
              path: "view/:type/:id",
              element: <CampaignView />,
            },
          ],
        },
        {
          path: "reports",
          children: [
            {
              path: "campaign-list",
              element: <CampaignListReport />,
            },
            {
              path: "financial-report",
              element: <FinancialReportChannelWise />,
            },
            // {
            //     path: 'financial-report',
            //     element: <FinancialReport/>
            // },
          ],
        },
        {
          path: "user",
          children: [
            {
              path: "list",
              element: <OwnerList role={role} />,
            },
            {
              path: "view/:id",
              element: <OwnerView />,
            },
          ],
        },
        {
          path: "child",
          children: [
            {
              path: "list",
              element: <ManageChildUserList role={role} />,
            },
            {
              path: "list/:id",
              element: <ChildUserList role={role} />,
            },
          ],
        },
      ],
    },
    {
      path: "unauthorized",
      element: <UnauthorizedAccess />,
    },
    {
      path: "",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "verify-login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <Navigate to="/unauthorized" />,
    },
  ];
}

export default ReportUserAuthorizedRoutes;
